import { PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import { Navbar } from '@ot/shared/model';
import { UIAppsBaseURLs, UserService } from '@ot/shared/utils';
import { UtilsService } from '@ot/shared/utils';

@Injectable({ providedIn: 'root' })
export class NavbarFactoryService {
  constructor(
    private platformLocation: PlatformLocation,
    private userService: UserService
  ) {}

  getNavbar(
    uiAppsBaseURLs: UIAppsBaseURLs,
    includeAdminLinks: boolean = false
  ): Navbar {
    const linksArray = [
      {
        name: 'Fuel',
        url: `${uiAppsBaseURLs.ifta}/fuel`,
        children: [
          {
            name: 'Fuel',
            url: `${uiAppsBaseURLs.ifta}/fuel`,
            exactMatch: true
          },
          { name: 'Imports', url: `${uiAppsBaseURLs.ifta}/fuel/imports` }
        ]
      },
      { name: 'Distance', url: `${uiAppsBaseURLs.ifta}/distance` },
      { name: 'Reports', url: `${uiAppsBaseURLs.reporting}` },
      { name: 'Tax Filings', url: `${uiAppsBaseURLs.ifta}/filings` },
      {
        name: 'Vehicles',
        url: `${
          uiAppsBaseURLs.dashboard
        }/vehicles/businessAccounts/${this.userService.getBusinessAccount()}`
      },
      {
        name: 'Administration',
        url: `${uiAppsBaseURLs.dashboard}/administration/labels`,
        children: [
          {
            name: 'Labels',
            url: `${uiAppsBaseURLs.dashboard}/administration/labels`,
            exactMatch: true
          }
        ]
      },
      { name: 'App Admin', url: `${uiAppsBaseURLs.ifta}/app-admin` },
      // { name: 'Legal', url: 'https://www.omnitracs.com/terms-use' },
      { name: 'Privacy Notice', url: `${uiAppsBaseURLs.ifta}/legal` },
      { name: 'Log out', url: this.buildLogoutUrl() }
          //'https://login.dev.omnitracs.com/logout.jsp?target=https://localhost:4200'
    ];

    if (includeAdminLinks) {
      linksArray.unshift({
        name: 'Business Accounts',
        url: `${uiAppsBaseURLs.dashboard}/business-accounts`
      });
    }

    return {
      title: 'Omnitracs Tax Manager',
      links: linksArray,
      helpLinks: [
        { name: 'Help', url: 'https://kb.omnitracs.com/Omnitracs_Tax_Manager' }
      ]
    };
  }

  private buildLogoutUrl() {
    return UtilsService.normalizeResourceUri(
      this.platformLocation.getBaseHrefFromDOM() + '/assets/logout.html'
    );
  }

  logOut(){
    localStorage.clear();
    sessionStorage.clear();
    // window.location.href = this.getLoginURL() + '/logout.jsp';
    return 'https://login.dev.omnitracs.com/logout.jsp?target=https://localhost:4200';
  }
  // To get the login url for rest api
  getLoginURL() {
    const hostArr = location.host.split('.');
    hostArr.shift();
    const DYNAMIC_ENV_DOMAIN = hostArr.join('.');
    return window.location.protocol + '//login.' + DYNAMIC_ENV_DOMAIN;
  }
}
